module.exports = ['$scope', function ($scope) {
        
    
}];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/noData/noDataCtrl.js
// module id = 365
// module chunks = 0